module.exports = __webpack_public_path__ + "sunsemweb/img/nbanner.ae644932.png";